// @ts-nocheck
import { useAuth } from 'src/context/auth.context'
import { appColors } from 'src/assets/styles/styles'
import { HiOutlineLogout } from 'react-icons/hi'
import { RiLockPasswordLine } from 'react-icons/ri'
import Spacer from 'src/components/view/Spacer'
import { useI18n } from 'src/context/i18n.context'

import styles from '../index.module.scss'

const SidebarFooter = () => {
  const { doLogout, handleModalChangePasswordVisibility } = useAuth()
  const { t } = useI18n()

  return (
    <div className={styles?.sidebarFooterContainer}>
      <div
        className={styles?.footerMenu}
        onClick={handleModalChangePasswordVisibility}>
        <RiLockPasswordLine color={appColors?.blue60} size={16} />
        <div className={styles?.footerMenuTxt}>{t('common.changePassword')}</div>
      </div>

      <Spacer margin=".5rem auto" />

      <div className={styles?.footerMenu} onClick={doLogout}>
        <HiOutlineLogout color={appColors?.blue60} size={16} />
        <div className={styles?.footerMenuTxt}>{t('common.signOut')}</div>
      </div>
    </div>
  )
}

export default SidebarFooter
